<template>
  <div>
    <Header :ifbluene="ifbluene"></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest" :thirdhref="thirdhref" :thirdtest="title"></breadcrumb>
    <div class="content-body body-box" style="overflow: hidden">
      <div class="main-item">
        <div class="body-left">
          <div class="test-box">
            <div class="test-head">
              <span class="test-title">新闻详情</span>
            </div>
          </div>
          <div style="background-color: #ffffff;">
            <h6>{{title}}</h6>
            <div style="color: #999999;margin-bottom: 20px;margin-top: 10px">
              <p style="display: inline">{{publisher}}</p><p style="display: inline;color:#e1e1e1;margin: 0px 10px">|</p><p style="display: inline;">{{create_time}}</p>
            </div>
            <div style="text-align: left;padding: 25px;font-size: 14px;">
              <div v-html="content"></div>
              <!--<p style="color: #0051bd;font-weight: 600">学会简介：</p>
              <p style="text-indent:2em;">
                广东省仪器仪表学会，英文名为GUANGDONG INSTRUMENT AND CONTROL SOCIETY，缩写为GDICS。广东省仪器仪表学会是广东省的仪器仪表科技工作者及有关组织组成的以促进仪器仪表及自动化科学技术发展和普及为宗旨的，具有公益性、学术性的社会团体，属非营利性的社会组织，是依法登记的法人社团，是广东省科学技术协会（简称广东科协）的组成部分。本会业务主管为广东省科协，本会受社团登记管理机关广东省民政厅的监督管理。
              </p>
              <p style="text-indent:2em;">
                广东省仪器仪表学会认真执行党的方针、政策；贯彻“百花齐放，百家争鸣”的方针；坚持民主办会原则，充分发扬学术民主，开展学术上的自由讨论；提倡辩证唯物主义和历史唯物主义，坚持实事求是、开拓创新、与时俱进的科学精神、科学态度和优良学风；团结和组织广大仪器仪表科技工作者，在改革开放中为繁荣我省仪器仪表事业、提高我省仪器仪表学术水平、振兴我省仪器仪表工业、加速实现我省社会主义现代化作出贡献。
              </p>-->
            </div>
          </div>
        </div>
        <!--<div class="body-right">
          <contact></contact>
        </div>-->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import contact from '@/components/contact/contact.vue'
import HttpServer from '@/utils' // 接口请求
import '../../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'newsArticle',
  data () {
    return {
      // 顶部导航栏
      ifbluene: {color: '#0051bd'},
      // 面包屑导航栏
      secondhref: '/news',
      secondtest: '学会新闻',
      thirdhref: '',
      // 文章标题
      title: '',
      // 文章内容
      content: '',
      // 发表时间
      create_time: '',
      // 作者
      publisher: ''
    }
  },
  mounted () {
    // 调用本页接口
    HttpServer.get('http://ysw.861718.com/gdics.php/index/detail?id=' + this.$route.params.id + '&tab=' + this.$route.params.tab).then(res => {
      this.title = res.data.title
      this.content = res.data.content
      this.create_time = res.data.create_time
      this.publisher = res.data.publisher
    })
  },
  components: {
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    contact: contact
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import '../joinprocess/main.css';
  .body-box{
    margin-top:10px;
    background-color: #f5f5f5;
    min-height: 600px;
  }
  .body-left{
    width: 950px;
    float: left;
  }
  .body-right{
    width: 200px;
    float: right;
  }
  .test-box{
    padding: 12px;
    background-color: #ffffff;
    font-size: 12px;
    text-align: left;
  }
  .test-head{
    height:30px;
    margin-bottom: 15px;
    border-bottom: 1px solid #d7d7d7;
  }
  .test-title{
    font-size: 14px
  }
</style>



// WEBPACK FOOTER //
// src/components/article/newsArticle.vue